import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { ScreenService } from './screen.service';

@Injectable()
export class MyMatPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();
  firstPageLabel = `Prima pagina`;
  itemsPerPageLabel = `Elementi per pagina:`;
  lastPageLabel = `Ultima Pagina`;
  nextPageLabel = 'Pagina successiva';
  previousPageLabel = 'Pagina precedente';

  constructor(
    private readonly screen: ScreenService,
  ) {}


  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      // return this.screen.isMobile() ? '' : 'Nessun dato presente';
      return '';
    }
    const startElement = (page * pageSize) + 1;
    const endElement = Math.min((page * pageSize) + pageSize, length)
    const amountPages = Math.ceil(length / pageSize);
    return this.screen.isMobile() ? `${startElement}-${endElement} di ${length}` : `${startElement}-${endElement} di ${length} elementi (pag. ${page + 1} di ${amountPages})`;
  }
}
